import { Flex } from '@buffer-mono/popcorn'

import { CommentIcon, LikeIcon, ShareIcon } from '../../../../assets/facebook'

import styles from './Post.module.css'

import type { JSX } from 'react'

export const FacebookPostActions = (): JSX.Element => {
  return (
    <Flex align="center" justify="around" className={styles.actions}>
      <Flex align="center" className={styles.action}>
        <LikeIcon size="small" color="currentColor" />
        Like
      </Flex>
      <Flex align="center" className={styles.action}>
        <CommentIcon size="small" color="currentColor" />
        Comment
      </Flex>
      <Flex align="center" className={styles.action}>
        <ShareIcon size="small" color="currentColor" />
        Share
      </Flex>
    </Flex>
  )
}
